import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ApplicationProvider } from "./context/application-context";
import { UserProvider } from "./context/user-context";
import * as serviceWorker from "./serviceWorker";
import "semantic-ui-less/semantic.less";
import "./styles/app.scss";
import "./styles/trinity-styles.scss";

const root = ReactDOM.createRoot(document.getElementById("app-root"));
root.render(
  <UserProvider>
    <ApplicationProvider>
      <App />
    </ApplicationProvider>
  </UserProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
